/**
 * 1) Оставляем хедер видимым (как раньше)
 * 2) Патчим методы hide() / checkLoadPosition()
 *    у sticky-header с type="always".
 */

/* ---------- 1. Показать то, что уже спрятали ---------- */
function showAlwaysStickyHeaders () {
  document
    .querySelectorAll('sticky-header[data-sticky-type="always"]')
    .forEach(sticky => {
      sticky.header?.classList.remove('shopify-section-header-hidden');
    });
}

/* ---------- 2. Патч прототипа ---------- */
function patchStickyHeader () {
  // ждём, пока Shopify зарегистрирует кастомный элемент
  const Sticky = customElements.get('sticky-header');
  if (!Sticky) {
    setTimeout(patchStickyHeader, 50);
    return;
  }

  /* запоминаем оригиналы */
  const origHide  = Sticky.prototype.hide;
  const origCLP   = Sticky.prototype.checkLoadPosition;

  /* заменяем */
  Sticky.prototype.hide = function () {
    if (this.getAttribute('data-sticky-type') === 'always') return;
    return origHide.apply(this, arguments);
  };

  Sticky.prototype.checkLoadPosition = function () {
    if (this.getAttribute('data-sticky-type') === 'always') return;
    return origCLP.apply(this, arguments);
  };
}

/* ---------- 3. Когда запускать ---------- */
function initFix () {
  patchStickyHeader();
  showAlwaysStickyHeaders();
}

document.addEventListener('DOMContentLoaded',            initFix);  // обычная загрузка
document.addEventListener('page:load',                   initFix);  // Turbolinks / Instant-page
document.addEventListener('shopify:section:load',        initFix);  // редактор темы
